// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vquoM","buttons":"styles_buttons__3Dyfv"};